import { useEffect, useState } from "react";
import { CalendarGreyIcon, ClocckGreyIcon, MailGreyIcon, StoreBlackIcon, TableFrontGreyIcon, TelephoneIcon, UserGreyIcon, UsersGreyIcon } from "../../../../assets/icons";
import { ReservationClientInfoDTO } from "../../../../models/reservation/reservation.response";
import { useNotification } from "../../../toster-notification/NotificationContext";
import { useAuth } from "../../../../auth/AuthContext";
import { error } from "console";
import { reservationService } from "../../../../services/reservationService";
import Loader from "../../../shared/Loader";
import { ReservationStatusType } from "../../../../models/base/ReservationStatusType";
import { ReservationStatus } from "../../../../utils/mappingEnums";
import { handleErrorNotification } from "../../../../utils/errorNotificatioMessage";



const ClientProfileReservationTab: React.FC = () => {

    const [reservations, setReservations] = useState<ReservationClientInfoDTO[]>([]);
    const [locals, setLocals] = useState<string[]>([]);

    const [filterText, setFilterText] = useState<string>("");
    const [filterLocal, setFilterLocal] = useState<string>("");
    const [filterDateFrom, setFilterDateFrom] = useState<string>(new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
    const [filterDateTo, setFilterDateTo] = useState<string>(new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
    const [filterReservationStatus, setFilterReservationStatus] = useState<ReservationStatusType | "">("");

    const [loading, setLoading] = useState<boolean>(true);
    const { notify } = useNotification();
    const { user } = useAuth();

    useEffect(() => {
        fetchReservations();
    }, [user]);


    const fetchReservations = async () => {
        if (!user) {
            notify("error", "Korisnik nije ulogovan");
            return;
        }

        setLoading(true);
        try {
            const response = await reservationService.getUserReservations(user.id, new Date(filterDateFrom), new Date(filterDateTo), filterReservationStatus);
            if (response.success && response.data) {
                setReservations(response.data);
                setLocals(Array.from(new Set(response.data.map(r => r.localName))));
            } else {
                notify("error", response.message || "Greska prilikom ucitavanja rezervacija");
            }
        } catch (error) {
            notify("error", "Greska prilikom ucitavanja rezervacija");
        } finally {
            setLoading(false);
        }
    };

    const cancelReservation = async (reservationId: string) => {
        setLoading(true);
        try {
            const response = await reservationService.cancelReservation(reservationId);
            if (response.success) {
                notify("success", "Rezervacija je otkazana");
                fetchReservations();
            } else {
                notify("error", response.message || "Greska prilikom otkazivanja rezervacije");
            }
        } catch (error: any) {
            notify("error", "Greska prilikom otkazivanja rezervacije");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setFilterText("");
        setFilterLocal("");
        setFilterDateFrom(new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
        setFilterDateTo(new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
        setFilterReservationStatus("");
    };


    const reservationStatusClass = (status: ReservationStatusType): string => {
        switch (status) {
            case ReservationStatusType.Waiting:
                return "grey-bg";
            case ReservationStatusType.Confirmed:
                return "green-bg";
            case ReservationStatusType.Canceled:
                return "red-bg";
            case ReservationStatusType.Finished:
                return "";
            case ReservationStatusType.DontShowUp:
                return "red-bg";
            default:
                return "";
        }
    };


    if (loading) {
        return <Loader />
    }


    return (
        <>
            <div className="admin-settings-box-div filter">
                <div className="filter-header-div">
                    <div className="fs-1-25rem">Filteri</div>
                </div>
                <div className="w-form">
                    <form className="form-8">

                        <div className="filter-div">
                            <div className="description-text">Pretraga</div>
                            <input className="form-input grey w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="text"
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                            />
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Lokal</div>
                            <select className="form-select grey auto-width w-select"
                                value={filterLocal}
                                onChange={(e) => setFilterLocal(e.target.value)}
                            >
                                <option value="">Bilo koji</option>
                                {locals.map((local) => (
                                    <option key={local} value={local}>{local}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Datum od</div>
                            <input className="form-input grey w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="date"
                                value={filterDateFrom}
                                onChange={(e) => setFilterDateFrom(e.target.value)}
                            />
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Datum do</div>
                            <input className="form-input grey w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="date"
                                value={filterDateTo}
                                onChange={(e) => setFilterDateTo(e.target.value)}
                            />
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Status</div>
                            <select className="form-select grey auto-width w-select"
                                value={filterReservationStatus}
                                onChange={(e) => setFilterReservationStatus(e.target.value as ReservationStatusType | "")}
                            >
                                <option value="">Bilo koji</option>
                                <option value={ReservationStatusType.Waiting}>Na čekanju</option>
                                <option value={ReservationStatusType.Confirmed}>Potvrđeno</option>
                                <option value={ReservationStatusType.Canceled}>Otkazano</option>
                                <option value={ReservationStatusType.DontShowUp}>Nije došao</option>
                                <option value={ReservationStatusType.Finished}>Završeno</option>

                            </select>
                        </div>

                    </form>
                </div>
                <div className="filter-bottom-div">
                    <div className="fs-1rem description-text">
                        Prikazano: <span className="text-span-7">{reservations.length} </span>
                        {/* od 9 rezervacija */}
                    </div>
                    <div className="filter-bouttons-div">
                        <div className="small-box-div transparent-border pointer" onClick={() => resetFilters()}>
                            <div>Resetuj</div>
                        </div>
                        <div className="small-box-div light-blue-bg pointer height-35px width-200px" onClick={() => fetchReservations()}>
                            <div>Primeni filtere</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="user-page-reservation-list-div">

                {reservations.length === 0 ? (
                    <div className="description-text">Nemate rezervacija</div>
                ) : (
                    reservations
                        .filter((reservation) => {
                            const searchText = filterText.toLowerCase();
                            if (!reservation.localName.toLowerCase().includes(searchText) &&
                                !reservation.fullName.toLowerCase().includes(searchText) &&
                                !reservation.email.toLowerCase().includes(searchText) &&
                                !reservation.phoneNumber.toLowerCase().includes(searchText) &&
                                !reservation.tableNumber?.toString().includes(searchText) &&
                                !reservation.id.toLowerCase().includes(searchText)) {
                                return false;
                            }

                            if (filterLocal && reservation.localName !== filterLocal) {
                                return false;
                            }

                            return true;
                        })
                        .map((reservation) => (
                            <div className="admin-settings-box-div">
                                <div className="admin-settings-box-header-div">
                                    <div className="admin-settings-box-header-info-div">
                                        <div className="admin-settings-box-header-info-title-div">
                                            <img src={StoreBlackIcon} loading="lazy" alt="" className="icon-size-20" />
                                            <div className="admin-settings-box-header-info-title">{reservation.localName}</div>
                                        </div>
                                        <div className="description-text">Rezervacija #res-1</div>
                                    </div>
                                    <div className="admin-settings-box-header-actions-div">
                                        <div className={`small-box-div ${reservationStatusClass(reservation.status)}`}>
                                            <div>{ReservationStatus(reservation.status)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-body-div">
                                    {reservation.isForAnotherPerson && (
                                        <div className="user-profile-user-info">
                                            <div className="text-block-33">Podaci o rezervaciji:</div>
                                            <div className="div-block-54">
                                                <div className="div-block-53">
                                                    <img src={UserGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                    <div className="text-block-34">{reservation.fullName}</div>
                                                </div>
                                                <div className="div-block-53">
                                                    <img src={MailGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                    <div>{reservation.email}</div>
                                                </div>
                                                <div className="div-block-53">
                                                    <img src={TelephoneIcon} loading="lazy" alt="" className="icon-size-20" />
                                                    <div>{reservation.phoneNumber}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="div-block-46">
                                        <div className="div-block-43">
                                            <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                            <div className="div-block-44">
                                                <div className="description-text">Datum i vreme</div>
                                                <div className="text-block-32">{new Date(reservation.reservationDate).toLocaleString()}</div>
                                            </div>
                                        </div>
                                        <div className="div-block-43">
                                            <img src={UsersGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                            <div className="div-block-44">
                                                <div className="description-text">Broj gostiju</div>
                                                <div className="text-block-32">{reservation.numberOfPeople}</div>
                                            </div>
                                        </div>
                                        <div className="div-block-43">
                                            <img src={TableFrontGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                            <div className="div-block-44">
                                                <div className="description-text">Sto</div>
                                                <div className="text-block-32">{reservation.tableNumber || "Sto još nije dodeljen"}</div>
                                            </div>
                                        </div>
                                        <div className="div-block-43">
                                            <img src={ClocckGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                            <div className="div-block-44">
                                                <div className="description-text">Kreirano</div>
                                                <div className="text-block-32">{new Date(reservation.createdAt).toLocaleString()}</div>
                                            </div>
                                        </div>
                                        <div id="w-node-_9bb4b3b0-32d1-6109-49a1-bd172f01bb2f-d5e61be0" className="div-block-43">
                                            <div className="div-block-44">
                                                <div className="description-text">Napomena</div>
                                                <div className="input-div">
                                                    <div>{reservation.description || "/"}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {reservation.status === ReservationStatusType.Waiting && (
                                        <>
                                            <div className="admin-settings-box-body-hr"></div>
                                            <div className="button-primary red-bg align-left" onClick={() => cancelReservation(reservation.id)}>
                                                <div>Otkazi reservaciju</div>
                                            </div>
                                        </>
                                    )}

                                </div>
                            </div>
                        ))
                )}
            </div>
        </>
    );
};

export default ClientProfileReservationTab;